import { SubMainHeaderContainer } from 'src/components/subheader/SubHeader.style';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { BrowseItemsType } from 'src/utils/constants/TvShowDetailsPageConstants';

import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import {
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_ELEMENT,
  MIXPANEL_TAB_NAME,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_TABS_HEADER,
  MIXPANEL_CONTENT_NAME,
  MIXPANEL_CONTENT_ID
} from '../../utils/analytics/mixpanel/mixpanelConstants';
type SubheaderItemsProps = {
  data: BrowseItemsType;
  genreLanguageClick: (item: string) => void;
  horizontalIndex: number;
  contentName?: string;
  contentId?: string;
  pageName?: string;
};

const SubheaderItem = (props: SubheaderItemsProps) => {
  const {
    data,
    genreLanguageClick,
    horizontalIndex,
    contentName,
    contentId,
    pageName
  } = props;
  const handleClick = (item: string) => {
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] = horizontalIndex || 'N/A';
    mixpanelObject[MIXPANEL_ELEMENT] = data?.id || 'N/A';
    mixpanelObject[MIXPANEL_TAB_NAME] = data?.id || 'N/A';
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_TABS_HEADER;
    mixpanelObject[MIXPANEL_CONTENT_NAME] = contentName || 'N/A';
    mixpanelObject[MIXPANEL_CONTENT_ID] = contentId || 'N/A';
    ctaEvent();

    genreLanguageClick(item.toLowerCase());
  };
  return (
    <SubMainHeaderContainer
      data-testid={`itemContainerDiv-${data?.id}`}
      onClick={() => handleClick(data && data?.id)}>
      <span data-testid={`itemDiv-${data?.id}`}>{data?.id}</span>
    </SubMainHeaderContainer>
  );
};

export default SubheaderItem;
